import * as angular from "angular";
import * as _ from "lodash"
import {QuantitySettingType} from "../types/quantitySetting.type";

angular
  .module('bringoz.admin.pricePlan')
  .filter('quantityValueText', quantityValueText);

/* @ngInject */
function quantityValueText(splitService, $translate) {
  return function quantityValueTextFilter(quantitySetting, priceType) {

    const siteCurrencySymbol = splitService.getCurrencySymbol();

    const quantityValue = _.get(quantitySetting, 'value');
    const quantityType = _.get(quantitySetting, 'type');
    const quantityTypeAddOrReduceSymbol = _getQuantityTypeAddOrReduceSymbol(quantityType);
    const quantityTypeChargeSymbol= _getQuantityTypeChargeSymbol(quantityType);

    const priceTypeTranslated = $translate.instant('PROGRAM_PRICE_TYPE.' + priceType);

    const text = quantityType === QuantitySettingType.TotalFixedPrice ?
      `${$translate.instant('For all')} ${priceTypeTranslated}` :
      $translate.instant('PROGRAM_PRICE_TYPE.' + priceType);

    function _getQuantityTypeAddOrReduceSymbol(type: QuantitySettingType) {
      let symbol;
      switch(type) {
        case QuantitySettingType.Surcharge: {
          symbol = '+';
          break;
        }
        case QuantitySettingType.SurchargePercentage: {
          symbol = '+';
          break;
        }
        case QuantitySettingType.Discount: {
          symbol = '-';
          break;
        }
        case QuantitySettingType.DiscountPercentage: {
          symbol = '-';
          break;
        }
        default: {
          symbol = '';
          break;
        }
      }
      return symbol;
    }

    function _getQuantityTypeChargeSymbol(type: QuantitySettingType) {
      let symbol;
      switch(type) {
        case QuantitySettingType.SurchargePercentage: {
          symbol = '%';
          break;
        }
        case QuantitySettingType.DiscountPercentage: {
          symbol = '%';
          break;
        }
        default: {
          symbol = siteCurrencySymbol;
          break;
        }
      }
      return symbol;
    }

    return `${quantityTypeAddOrReduceSymbol} ${quantityValue}${quantityTypeChargeSymbol} ${text}`;
  }
}
